import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {SearchFilterComponent} from './components/search-filter/search-filter.component';
import {SearchFilterOverlayComponent} from './components/search-filter-overlay/search-filter-overlay.component';
import {ColorFilterComponent} from './components/color-filter/color-filter.component';
import {ProductCategoryComponent} from './components/product-category/product-category.component';
import {I18NextModule} from 'angular-i18next';
import {ProductSectionsFilterComponent} from './components/product-sections-filter/product-sections-filter.component';
import {SearchResultsComponent} from './components/search-results/search-results.component';
import {ShapeFilterComponent} from './components/shape-filter/shape-filter.component';
import {SearchFilterRoutingModule} from './search-filter-routing.module';
import {CoreModule} from '../../core/core.module';
import {NgxPaginationModule} from 'ngx-pagination';


@NgModule({
  declarations: [
    SearchFilterComponent,
    SearchFilterOverlayComponent,
    ColorFilterComponent,
    ProductSectionsFilterComponent,
    ProductCategoryComponent,
    ShapeFilterComponent,
    SearchResultsComponent
  ],
  exports: [
    SearchFilterComponent,
    SearchFilterOverlayComponent
  ],
  imports: [
    CommonModule,
    NgxSliderModule,
    FormsModule,
    NgSelectModule,
    SearchFilterRoutingModule,
    I18NextModule,
    NgxPaginationModule,
    CoreModule
  ]
})
export class SearchFilterModule {
}



